/* Renoura bundle builder (Eve Curls style "Buy 3, get 3 free"). Custom element <renoura-bundle>.
   Used twice: the bundle page (section renoura-bundle, goes straight to checkout) and the set builder inside the
   product page buy box (data-mode="drawer": adds to the cart and opens the cart drawer). Every part of the markup is
   optional, so both layouts can use the same element. Shows the expected total; the discount itself is an
   automatic discount in the Shopify admin. Fires "rb:change" after every render (the product page button listens).
   4 Nov 2026 (Perfect Curls Set): extras may sit outside the element (data-extras="#id", toggle switches with
   data-rb-switch), [save]/[free] placeholders, (i) dialogs (data-rb-info="dialog id"). */
(function () {
  if (customElements.get('renoura-bundle')) return;

  const root = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const SECTIONS = 'cart-drawer,cart-icon-bubble';

  class RenouraBundle extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.need = Number(this.dataset.need) || 6;
      this.freeMax = Number(this.dataset.free) || 3;
      this.max = Number(this.dataset.max) || 0; // 0 = no upper limit
      this.items = [...this.querySelectorAll('[data-rb-item]')].map((el) => ({
        el,
        variant: el.dataset.variant,
        price: Number(el.dataset.price) || 0,
        name: el.dataset.name,
        image: el.dataset.image,
        qty: Number(el.dataset.qty) || 0,
      }));
      // Coming from the curl quiz (?quiz_handles=a,b,c): start with the bundle spread over the recommended products.
      const fromQuiz = new URLSearchParams(window.location.search).get('quiz_handles');
      if (fromQuiz && !this.items.some((i) => i.qty > 0)) {
        const picked = this.items.filter((i) => fromQuiz.split(',').includes(i.el.dataset.handle));
        picked.forEach((i, k) => {
          i.qty = Math.floor(this.need / picked.length) + (k < this.need % picked.length ? 1 : 0);
        });
      }
      // Format like Shopify's money filter: data-money-sample is "{{ 123456 | money }}" (e.g. "€1.234,56" or "£1,234.56").
      const sample = this.dataset.moneySample || '';
      const m = sample.match(/^(.*?)1([.,'\s]?)234([.,])56(.*)$/);
      this.money = (cents) => {
        if (m) {
          const [, pre, thou, dec, post] = m;
          const whole = Math.floor(Math.abs(cents) / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, thou);
          const frac = String(Math.abs(cents) % 100).padStart(2, '0');
          return `${cents < 0 ? '-' : ''}${pre}${whole}${dec}${frac}${post}`;
        }
        try {
          return new Intl.NumberFormat(this.dataset.locale || undefined, {
            style: 'currency',
            currency: this.dataset.currency || 'EUR',
          }).format(cents / 100);
        } catch (e) {
          return (cents / 100).toFixed(2);
        }
      };
      // [count] = items picked or still to pick (depends on the text), [free] = free items, [save] = money saved.
      this.fill = (tpl, count, extra) =>
        (tpl || '')
          .replace('[count]', count)
          .replace('[free]', extra && extra.free != null ? extra.free : '')
          .replace('[save]', extra && extra.save != null ? extra.save : '');
      this.gifts = [...this.querySelectorAll('[data-rb-gift]')].map((el) => el.dataset.variant).filter(Boolean);
      // Extras may live outside the element (product page: after the add-to-cart button), see data-extras="#id".
      this.extrasRoot = this.dataset.extras ? document.querySelector(this.dataset.extras) : null;
      this.extras = [...(this.extrasRoot || this).querySelectorAll('[data-rb-extra]')].map((el) => ({ el, variant: el.dataset.variant, on: false }));
      this.addEventListener('click', (e) => this.onClick(e));
      if (this.extrasRoot) this.extrasRoot.addEventListener('click', (e) => this.onClick(e));
      // (i) buttons open a <dialog> with the product story and how to use it.
      this.querySelectorAll('[data-rb-close]').forEach((btn) => btn.addEventListener('click', () => btn.closest('dialog').close()));
      this.querySelectorAll('dialog.rbi__dialog').forEach((d) => d.addEventListener('click', (e) => { if (e.target === d) d.close(); }));
      this.cta = this.querySelector('[data-rb-cta]');
      if (this.cta) this.cta.addEventListener('click', () => this.checkout(this.cta));
      this.render();
    }

    count() {
      return this.items.reduce((n, i) => n + i.qty, 0);
    }

    onClick(e) {
      const infoBtn = e.target.closest('[data-rb-info]');
      if (infoBtn) {
        e.preventDefault();
        e.stopPropagation();
        const dialog = document.getElementById(infoBtn.dataset.rbInfo);
        if (dialog && typeof dialog.showModal === 'function') dialog.showModal();
        return;
      }
      const extraBtn = e.target.closest('[data-rb-extra-toggle]');
      if (extraBtn) {
        const extra = this.extras.find((x) => x.el === extraBtn.closest('[data-rb-extra]'));
        if (extra) {
          extra.on = !extra.on;
          this.render();
        }
        return;
      }
      const row = e.target.closest('[data-rb-item]');
      if (!row) return;
      const item = this.items.find((i) => i.el === row);
      if (!item) return;
      if (e.target.closest('[data-rb-add]') || e.target.closest('[data-rb-plus]')) {
        if (this.max && this.count() >= this.max) return;
        item.qty += 1;
      } else if (e.target.closest('[data-rb-minus]')) item.qty = Math.max(0, item.qty - 1);
      else return;
      this.render();
    }

    totals() {
      const count = this.count();
      const prices = [];
      this.items.forEach((i) => {
        for (let k = 0; k < i.qty; k += 1) prices.push(i.price);
      });
      prices.sort((a, b) => a - b);
      const sum = prices.reduce((a, b) => a + b, 0);
      // Same rule as the discount: every 2 items 1 free, at most freeMax, cheapest first.
      const free = count >= this.need ? Math.min(Math.floor(count / 2), this.freeMax) : 0;
      const off = prices.slice(0, free).reduce((a, b) => a + b, 0);
      return { count, sum, free, now: sum - off };
    }

    render() {
      const t = this.totals();
      const left = Math.max(0, this.need - t.count);
      const unlocked = left === 0;
      const full = this.max > 0 && t.count >= this.max;
      const $ = (sel) => this.querySelector(sel);

      this.items.forEach((i) => {
        const add = i.el.querySelector('[data-rb-add]');
        const stepper = i.el.querySelector('[data-rb-stepper]');
        if (add) add.hidden = i.qty > 0;
        if (stepper) {
          if (add) stepper.hidden = i.qty === 0;
          stepper.querySelector('[data-rb-count]').textContent = i.qty;
          const minus = stepper.querySelector('[data-rb-minus]');
          const plus = stepper.querySelector('[data-rb-plus]');
          if (minus) minus.disabled = i.qty === 0;
          if (plus) plus.disabled = full;
        }
        if (add) add.disabled = full;
        i.el.classList.toggle('is-picked', i.qty > 0);
      });

      const fillEl = $('[data-rb-fill]');
      const bar = $('[data-rb-bar]');
      if (fillEl) fillEl.style.width = Math.min(100, Math.round((t.count / this.need) * 100)) + '%';
      if (bar) bar.setAttribute('aria-valuenow', Math.min(t.count, this.need));
      this.querySelectorAll('[data-rb-dots] > *').forEach((d, k) => d.classList.toggle('is-on', k < t.count));
      const tally = $('[data-rb-tally]');
      if (tally) {
        tally.textContent = `${Math.min(t.count, this.need)}/${this.need}${unlocked ? ' ✓' : ''}`;
        tally.classList.toggle('is-done', unlocked);
      }
      const saveText = this.money(t.sum - t.now);
      const progress = $('[data-rb-progress-text]');
      if (progress) {
        progress.textContent = unlocked
          ? this.fill(this.dataset.tDone, t.count, { free: t.free, save: saveText })
          : this.fill(this.dataset.tMore, left, { free: this.freeMax, save: saveText });
        progress.classList.toggle('is-done', unlocked);
      }
      const saveEl = $('[data-rb-save]');
      if (saveEl) {
        saveEl.hidden = !unlocked || !this.dataset.tSave;
        if (unlocked) saveEl.textContent = this.fill(this.dataset.tSave, t.count, { free: t.free, save: saveText });
      }

      const totalLabel = $('[data-rb-total-label]');
      if (totalLabel) totalLabel.textContent = this.fill(this.dataset.tTotal, t.count);
      const now = $('[data-rb-now]');
      if (now) now.textContent = this.money(t.now);
      const was = $('[data-rb-was]');
      if (was) {
        was.hidden = t.free === 0;
        was.textContent = t.free > 0 ? this.money(t.sum) : '';
      }
      const note = $('[data-rb-note]');
      if (note) {
        note.textContent = unlocked
          ? this.fill(this.dataset.tFree, t.free)
          : t.count > 0
            ? this.fill(this.dataset.tUnlock, left)
            : '';
      }

      const thumbs = $('[data-rb-thumbs]');
      if (thumbs) {
        thumbs.innerHTML = '';
        this.items.forEach((i) => {
          if (!i.qty) return;
          const span = document.createElement('span');
          span.className = 'rb__thumb';
          if (i.image) {
            const img = document.createElement('img');
            img.src = i.image;
            img.alt = i.name;
            span.appendChild(img);
          }
          const q = document.createElement('b');
          q.textContent = i.qty + 'x';
          span.appendChild(q);
          thumbs.appendChild(span);
        });
      }

      this.extras.forEach((x) => {
        const btn = x.el.querySelector('[data-rb-extra-toggle]');
        x.el.classList.toggle('is-picked', x.on);
        if (!btn) return;
        btn.setAttribute('aria-pressed', String(x.on));
        if (btn.hasAttribute('data-rb-switch')) {
          btn.setAttribute('aria-checked', String(x.on));
          return;
        }
        btn.textContent = x.on ? '✓ ' + (this.dataset.tExtraAdded || '') : this.dataset.tExtraAdd;
      });

      if (this.cta) this.cta.disabled = !unlocked;
      // Bundle page only: the bar shows once something is picked; the normal sticky add-to-cart steps aside (Stijn, 19 Oct).
      const sticky = $('[data-rb-sticky]');
      if (sticky) {
        sticky.hidden = t.count === 0;
        document.body.classList.toggle('rb-has-items', t.count > 0);
      }

      this.state = { count: t.count, need: this.need, left, unlocked, now: t.now, sum: t.sum, nowText: this.money(t.now), wasText: t.free > 0 ? this.money(t.sum) : '' };
      this.dispatchEvent(new CustomEvent('rb:change', { bubbles: true, detail: this.state }));
    }

    async post(url, body) {
      const res = await fetch(url, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      });
      const json = await res.json().catch(() => ({}));
      if (!res.ok || json.status) throw new Error(json.description || 'add failed');
      return json;
    }

    // button: the element whose label shows "adding" (the bundle page CTA or the product page add-to-cart).
    async checkout(button) {
      if (!this.state || !this.state.unlocked || this.busy) return;
      this.busy = true;
      const err = this.querySelector('[data-rb-error]');
      if (err) err.hidden = true;
      const labelEl = button ? button.querySelector('span') || button : null;
      const label = labelEl ? labelEl.textContent : '';
      if (button) button.setAttribute('aria-disabled', 'true');
      if (labelEl) labelEl.textContent = this.dataset.tAdding || label;
      try {
        const lines = this.items.filter((i) => i.qty > 0).map((i) => ({ id: Number(i.variant), quantity: i.qty }));
        // Gifts once per cart (free products), skipped when already in the cart; plus the extras the customer ticked.
        if (this.gifts.length) {
          const cart = await fetch(root() + 'cart.js', { credentials: 'same-origin' }).then((r) => r.json()).catch(() => ({ items: [] }));
          const inCart = new Set((cart.items || []).map((i) => String(i.variant_id)));
          this.gifts.filter((id) => !inCart.has(String(id))).forEach((id) => lines.push({ id: Number(id), quantity: 1 }));
        }
        this.extras.filter((x) => x.on).forEach((x) => lines.push({ id: Number(x.variant), quantity: 1 }));

        const drawer = this.dataset.mode === 'drawer' ? document.querySelector('cart-drawer') : null;
        if (drawer && typeof drawer.renderContents === 'function') {
          const json = await this.post(root() + 'cart/add.js', { items: lines, sections: SECTIONS, sections_url: window.location.pathname });
          drawer.classList.remove('is-empty');
          drawer.renderContents({ id: json.id, sections: json.sections });
        } else {
          await this.post(root() + 'cart/add.js', { items: lines });
          window.location.href = root() + (this.dataset.mode === 'drawer' ? 'cart' : 'checkout');
          return; // busy stays on: the page is leaving
        }
      } catch (e) {
        if (err) {
          err.textContent = this.dataset.tError;
          err.hidden = false;
        }
      }
      this.busy = false;
      if (labelEl) labelEl.textContent = label;
      if (button) button.removeAttribute('aria-disabled');
      this.render();
    }
  }

  customElements.define('renoura-bundle', RenouraBundle);
})();
